export {default} from './MainContainer';



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/MainContainer/index.ts